var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Observable = (function (Observable) {

        Observable = function(model) {

            if (typeof model !== 'object')
                throw new Error('The model must be type of object.');

            this.model = model;
            this.children = {};

            this.propertyChangingEvents = {};
            this.propertyChangedEvents = {};

            this.DefineProperties();
        }

       
        
        
       Observable.prototype.GetNotificationList = function(events, propName) {
            var propertyNotifiers = events[propName];
            if (!propertyNotifiers) {
                propertyNotifiers = [];
                events[propName] = propertyNotifiers;
            };

            return propertyNotifiers;
        };

        Observable.prototype.FindEvent = function(notificationList, event) {
            for (var i = 0, n = notificationList.length; i < n; i++) {
                if (notificationList[i] === event)
                    return i;
            };

            return -1;
        };

        Observable.prototype.GetChildObservable = function(propName) {
            for (var child in this.children) {
                if (this.children.hasOwnProperty(child)) {
                    if (child === propName)
                        return this.children[propName];
                }
            };

            return null;
        };

        Observable.prototype.GetChildObservableByPath = function (propertyPath) {
            var innerData = this;

            var propertyPathParts = propertyPath.split('.');
            if (propertyPathParts.length > 1) {
                for (var j = 0; j < propertyPathParts.length - 1; j++) {
                    innerData = innerData.GetChildObservable(propertyPathParts[j]);
                }
            }

            return innerData;
        };

        Observable.prototype.GetModel = function() {
            return this.model;
        };

        Observable.prototype.DefineProperties = function() {
            for (var propName in this.model) {
                if (this.model.hasOwnProperty(propName)) {
                    var propValue = this.model[propName];
                    var propType = typeof propValue;

                    if (Array.isArray(propValue)) {
                        //throw new Error('DefineProperties for array is not implemented yet!');
						delete this.model.propName;
                    } else if (propType === 'string' || propType === 'number' || propType === 'boolean') {
                        this.DefineProperty(propName, propValue);
                    } else if (propType === 'object') {
                        this.children[propName] = new Vendd.Observable(propValue);
                    };
                };
            };
        };

        Observable.prototype.DefineProperty = function (propName, value) {
            Object.defineProperty(this, propName, {
                set: function(value) {
                    this.NotifyPropertyChanging(propName, value);
                    this.model[propName] = value;
                    this.NotifyPropertyChanged(propName, value);
                },
                get: function() {
                    return this.model[propName];
                }
            });
        };

        Observable.prototype.NotifyPropertyChanging = function (propName, value) {
            var propertyNotifiers = this.GetNotificationList(this.propertyChangingEvents, propName);
            for (var i = 0, n = propertyNotifiers.length; i < n; i++) {
                propertyNotifiers[i](this, propName, value);
            };
        };

        Observable.prototype.NotifyPropertyChanged = function (propName, value) {
            var propertyNotifiers = this.GetNotificationList(this.propertyChangedEvents, propName);
            for (var i = 0, n = propertyNotifiers.length; i < n; i++) {
                propertyNotifiers[i](this, propName, value);
            };
        };

        Observable.prototype.SetModel = function(model) {
            this.model = model;
            for (var propName in this.model) {
                if (this.model.hasOwnProperty(propName)) {
                    var propValue = this.model[propName];
                    var propType = typeof propValue;

                    if (Array.isArray(propValue)) {
                        this.NotifyPropertyChanged(propName, propValue); // need to check this
                    } else if (propType === 'string' || propType === 'number' || propType === 'boolean') {
                        this.NotifyPropertyChanged(propName, propValue);
                    } else if (propType === 'object') {
                        this.children[propName].SetModel(propValue);
                    };
                };
            };
        };

        Observable.prototype.AddListenerToPropertyChanging = function(propName, eventListenerFn) {
            if (typeof (eventListenerFn) === 'function') {
                var propertyNotifiers = this.GetNotificationList(this.propertyChangingEvents, propName);
                var pos = this.FindEvent(propertyNotifiers, eventListenerFn);
                if (pos === -1)
                    propertyNotifiers.push(eventListenerFn);
            };
        };

        Observable.prototype.AddListenerToPropertyChanged = function(propName, eventListenerFn) {
            if (typeof (eventListenerFn) === 'function') {
                var propertyNotifiers = this.GetNotificationList(this.propertyChangedEvents, propName);
                var pos = this.FindEvent(propertyNotifiers, eventListenerFn);
                if (pos === -1)
                    propertyNotifiers.push(eventListenerFn);
            };
        };

        Observable.prototype.RemoveListenerToPropertyChanging = function(propName, eventListenerFn) {
            if (typeof (eventListenerFn) === 'function') {
                var propertyNotifiers = this.GetNotificationList(this.propertyChangingEvents, propName);
                var pos = this.FindEvent(propertyNotifiers, eventListenerFn);
                if (pos === -1)
                    propertyNotifiers.splice(pos, 1);
            };
        };

        Observable.prototype.RemoveListenerToPropertyChanged = function(propName, eventListenerFn) {
            if (typeof (eventListenerFn) === 'function') {
                var propertyNotifiers = this.GetNotificationList(this.propertyChangedEvents, propName);
                var pos = this.FindEvent(propertyNotifiers, eventListenerFn);
                if (pos === -1)
                    propertyNotifiers.splice(pos, 1);
            };
        };

        return Observable;

    })(Vendd.Observable || {});

    return Vendd;

})(Vendd || {});